import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { LoyaltyInfo } from '@/core/payment-card/interfaces';
import { CurrencyInfo } from '@/core/currency/interfaces';
import { isMobileDevice } from '@/core/helpers/devices';
import { formatCurrency } from '@/core/currency/helpers';
import {
    LoyaltyInput,
    LoyaltySlider,
    LoyaltySelect,
    LoyaltySingleOffer,
    LoyaltyMultipleOffers
} from './components';

@Component({
    data() {
        return {
            redeemedLoyaltyAmount: null
        };
    },
    components: {
        LoyaltyInput,
        LoyaltySlider,
        LoyaltySelect,
        LoyaltySingleOffer,
        LoyaltyMultipleOffers
    }
})
export default class CardLoyalty extends Vue {
    @Prop(Number)
    value: number;

    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Number)
    amount: number;

    @Prop(Number)
    sliderPrecision: number;

    @Prop(Boolean)
    useInput: boolean;

    @Prop(Boolean)
    useSlider: boolean;

    @Prop(Boolean)
    useDropDown: boolean;

    @Prop(Boolean)
    hasOffers: boolean;

    @Prop(Boolean)
    loading: boolean;

    redeemedLoyaltyAmount: number;

    mounted() {
        this.redeemedLoyaltyAmount = this.value;
    }

    get isMobileDevice() {
        return isMobileDevice();
    }

    get calculatedRemainingAmount() {
        let finalAmount = this.amount - this.redeemedLoyaltyAmount / 100;

        if (this.useInput) {
            finalAmount = this.amount - this.redeemedLoyaltyAmount;
        }

        return formatCurrency(
            finalAmount > 0 ? finalAmount.toFixed(2) : '0',
            this.currency?.format,
            '0,0.00'
        );
    }

    selectOffers(value) {
        this.$emit('select:offers', value);
    }

    @Watch('redeemedLoyaltyAmount')
    onChangeRedeemedLoyaltyAmount(value) {
        this.$emit('input', value);
    }

    @Watch('value')
    onChangeValue() {
        this.redeemedLoyaltyAmount = this.value;
    }
}
